import { css } from '@inter-ikea-kompis/web-component';

export default class OpenDesignCodeInputStyle {
	public static getStyle(): string {
		return css`
			:host {
				width: 100%;
			}
			skapa-input-field {
				flex-shrink: 0;
				width: 100%;
			}
			input {
				text-transform: uppercase;
			}
		`;
	}
}
